import React from 'react'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { useStoreActionTypeMutation, useUpdateActionTypeMutation } from '../../services/actionType'
import { useActionType } from '../../hooks/useActionType'
import { validationSchema } from './schemas'

export function ActionTypeForm({ children }) {
  const history = useHistory()

  const { isNewActionType, actionTypeId, actionType } = useActionType()

  const [updateActionType] = useUpdateActionTypeMutation()
  const [storeActionType] = useStoreActionTypeMutation()

  async function onSubmit(values) {
    const payload = {
      name: values.name,
      active: values.active || false,
      attachmentId: values.actionAttachmentId || null,
      extra: {
        locationTypesIds: values.locationTypesIds || [],
        memberTypesIds: values.memberTypesIds || []
      }
    }

    if (isNewActionType) {
      const { data } = await storeActionType({ payload })
      if (data?.id) {
        history.push(`/actionTypes/${data.id}`)
      }
    } else {
      await updateActionType({ actionTypeId, payload })
    }
  }

  return (
    <Formik
      enableReinitialize
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      validateOnBlur={false}
      initialValues={{
        name: actionType?.name || '',
        active: actionType?.active || true,
        memberTypesIds: actionType?.memberTypes || [],
        locationTypesIds: actionType?.locationTypes || [],
        actionAttachmentId: actionType?.attachmentId || null
      }}
    >
      {children}
    </Formik>
  )
}
